import React, {lazy, Suspense} from 'react'

const PrayerLandingPageLazy = lazy(() =>
    import('./PrayerLandingPage')
)

const PrayerLandingPage = props => (
    <Suspense fallback={null}>
        <PrayerLandingPageLazy {...props} />
    </Suspense>
)

export default PrayerLandingPage
